import React from 'react';
import {
  SettingsLayout,
  UserSettingsGeneral,
  UserSettingsAppearanceCard,
  UserSettingsIdentityCard,
  UserSettingsFeatureFlags,
  UserSettingsAuthProviders,
  userSettingsPlugin, // <-- import the plugin to access its routeRef
} from '@backstage/plugin-user-settings';
import { attachComponentData } from '@backstage/core-plugin-api'; // <-- import attachComponentData
import CustomSignOutButton from './CustomSignOutButton'
import GeneralSetting from './pages/GeneralSetting';
const CustomSettingsPage = () => {
  return (
    <SettingsLayout title="Settings">
      <SettingsLayout.Route path='sign out' title='GENERAL '>
        <CustomSignOutButton />
      </SettingsLayout.Route>  
      {/* <SettingsLayout.Route path="authetication-providers" title="AUTHENITICATION PROVIDERS">
        <UserSettingsAuthProviders />
      </SettingsLayout.Route>
      <SettingsLayout.Route path="feature-flags" title="FEATURES FLAGS">
        <UserSettingsFeatureFlags /> */}
      {/* </SettingsLayout.Route> */}
      <SettingsLayout.Route path='general' title='Organization Details'>
        <GeneralSetting />
      </SettingsLayout.Route> 


      {/* no "sign-out" route */}
    </SettingsLayout>
  );
};

// ⭐ This line tells Backstage that this component implements the 'user-settings' routeRef
attachComponentData(
  CustomSettingsPage,
  'core.mountPoint',
  userSettingsPlugin.routes.settingsPage,
);

export default CustomSettingsPage;
